import { dbPut } from '../core/db.js';
import { cardsOfCourse } from '../core/load.js';
import { state } from '../core/state.js';
import { $, DAY, dayKey, esc, fromKey, startOfDay } from '../core/text.js';
import { modal } from '../ui/modal.js';
import { toast } from '../ui/toast.js';
import { refresh } from '../ui/views.js';
import { isBlocked } from './calendar.js';

/* ══════════ Klausurplan ══════════ */
export function renderExam() {
  const course = state.courses.find((c) => c.id === state.selCourse);
  const body = $('#exam-body');
  $('#btn-exam').textContent = course?.examDate ? 'Termin ändern' : 'Termin setzen';
  $('#btn-exam').disabled = !course;
  if (!course) { body.innerHTML = '<p class="page-sub">Wähle einen Kurs, um einen Klausurtermin zu setzen.</p>'; return; }
  if (!course.examDate) {
    body.innerHTML = `<p class="page-sub">Kein Termin für „${esc(course.name)}". Setz einen – dann rechne ich dir ein Tagesziel aus.</p>`;
    return;
  }
  const cards = cardsOfCourse(course.id);
  const open = cards.filter((c) => c.level !== 'green').length;
  const days = Math.max(0, Math.ceil((fromKey(course.examDate).getTime() - startOfDay()) / DAY));
  // Lern-Pausen aus dem Kalender abziehen: nur Tage, an denen ich lernen kann, zählen fürs Tagesziel
  let blockedAhead = 0;
  for (let i = 0; i < days; i++) { if (isBlocked(dayKey(new Date(startOfDay() + i * DAY)))) blockedAhead++; }
  const usableDays = Math.max(0, days - blockedAhead);
  const perDay = usableDays > 0 ? Math.ceil(open / usableDays) : open;
  const todayCount = state.log.find((l) => l.day === dayKey())?.byCourse?.[course.id]?.count || 0;
  const pct = perDay ? Math.min(100, Math.round((todayCount / perDay) * 100)) : 100;
  body.innerHTML = `
    <div class="stat-grid" style="margin-bottom:14px">
      <div class="stat-tile"><div class="stat-num">${days === 0 ? 'Heute!' : days}</div>
        <div class="stat-lbl">${days === 0 ? 'Klausur ist heute' : days === 1 ? 'Tag bis Klausur' : 'Tage bis Klausur'}</div></div>
      <div class="stat-tile"><div class="stat-num">${open}</div><div class="stat-lbl">noch nicht grün</div></div>
      <div class="stat-tile"><div class="stat-num">${open ? perDay : '✓'}</div><div class="stat-lbl">Tagesziel</div></div>
    </div>
    <div class="stat-row-head"><b>Heute geschafft</b><span>${todayCount} / ${perDay || 0}</span></div>
    <div class="bar"><div class="bar-fill" style="width:${pct}%"></div></div>
    <p class="bar-note">Klausur am ${fromKey(course.examDate).toLocaleDateString('de', { weekday: 'long', day: 'numeric', month: 'long' })}
      ${blockedAhead ? ` · ${blockedAhead} Lern-Pause${blockedAhead === 1 ? '' : 'n'} berücksichtigt` : ''}${open === 0 ? ' · alles grün, du bist durch ✦' : days === 0 ? ' · viel Erfolg!' : ''}</p>
    <div class="row-actions"><button class="btn-ghost tiny outline" id="btn-exam-clear">Termin entfernen</button></div>`;
  $('#btn-exam-clear').onclick = () => removeExam(course.id);
}
export async function removeExam(courseId) {
  const course = state.courses.find((c) => c.id === courseId);
  if (!course?.examDate) return;
  delete course.examDate;
  await dbPut('courses', course);
  toast('Klausurtermin entfernt'); refresh();
}
export function examModal() {
  const course = state.courses.find((c) => c.id === state.selCourse);
  if (!course) return;
  modal({
    title: `Klausurtermin – ${course.name}`,
    body: `<div class="field"><label>Datum</label>
             <input type="date" class="input" id="m-date" value="${course.examDate || ''}" min="${dayKey()}"></div>
           <p class="page-sub">Aus offenen Karten und verbleibenden Tagen berechne ich dein Tagesziel.</p>`,
    onOk: async () => {
      const v = $('#m-date').value;
      if (!v) { toast('Bitte ein Datum wählen'); return false; }
      course.examDate = v; await dbPut('courses', course);
      toast('Termin gesetzt ✦'); refresh();
    },
  });
}

